var $ = jQuery.noConflict();

$('.js-add-unclickmask').on('click', function (e) {
    $('.unclickMask').addClass('active');
});

$('.unclickMask').on('click', function (e) {
    $(this).removeClass('active');

// add classes which you want remove after click on mask on body
    $('.page-header__hamburger--sidemenu .hamburger').removeClass('is-active');
    $('.nav-sidemenu').removeClass('active');

    $('.c-infobar__info-text').removeClass('active');
    $('.c-infobar__info').removeClass('active');
})
